module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am726-b41846544e80aca6eefd20eeeb88a88f.jpg";